import { useState } from "react";
import Label from "../../../components/Label";
import FormulaEditor from "./FormulaEditor";
import Button from "../../../components/Button";
import useLang from "../../../hooks/useLang";
import ConditionBlock from "./ConditionBlock";
import AddFormulaElementModal from "./AddFormulaElementModal";

const PriceFormulaBlock = ({
  constants,
  tokens,
  onChange,
  parameters,
  configParameters = [],
  getPrice,
  disableChange,
  onConditionChange,
}) => {
  const lang = useLang();
  const [isAddOpen, setIsAddOpen] = useState(false);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--gap)",
          padding: "0 var(--horizontal-padding)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ width: "var(--width-32)" }}>
            <Label>{lang("formula")}</Label>
          </div>
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "var(--gap)",
              }}
            >
              {tokens && tokens.length > 0 && (
                <FormulaEditor
                  constants={constants}
                  tokens={tokens}
                  onChange={onChange}
                  parameters={parameters}
                  getPrice={getPrice}
                />
              )}
              <div style={{ height: "var(--gap)" }} />
              <Button
                disabled={disableChange}
                onClick={() => setIsAddOpen(true)}
              >
                Pridėti elementą
              </Button>
            </div>
            {tokens && tokens.length > 0 && (
              <Button
                inline
                disabled={disableChange}
                icon="trashIcon"
                onClick={() => onChange([])}
              >
                Ištrinti formulę
              </Button>
            )}
          </div>
        </div>
      </div>
      <ConditionBlock parameters={configParameters} disableChange={disableChange} onConditionChange={onConditionChange} />
      <AddFormulaElementModal
        isOpen={isAddOpen}
        onClose={() => setIsAddOpen(false)}
        disableChange={disableChange}
        constants={constants}
        parameters={parameters}
        onAdd={(token) => onChange([...(tokens || []), token])}
      />
    </>
  );
};

export default PriceFormulaBlock;
